<template>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Testo bottone superiore" text="Testo bottone superiore"></localized-text>
        </label>
        <input class="form-control" type="text" v-model="localValue.topButtonText" />
    </div>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Href bottone superiore" text="Href bottone superiore"></localized-text>
        </label>
        <input class="form-control" type="text" v-model="localValue.topButtonHref" />
    </div>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Contenuto" text="Contenuto"></localized-text>
        </label>
        <rte-editor class="form-control" v-model="localValue.text" height="200"></rte-editor>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import { Options } from 'vue-class-component';
import { Mixins, Watch } from 'vue-property-decorator';
import WithModel from '@/mixins/withModel';

@Options({})
export default class bluePaintBlock extends Mixins(WithModel) {
    declare localValue: OM.BluePaintBlock;

    created(){
        if(!this.localValue.text){
            this.localValue.text = "";
        }
    }

    @Watch('localValue.topButtonText')
    @Watch('localValue.topButtonHref')
    @Watch('localValue.isFullWidth')
    @Watch('localValue.marginBottom')
    @Watch('localValue.text')
    onTextChange(){
        this.localValue.htmlText = `
            <div class="bluePaint bluePaintBlock ${(!this.localValue.isFullWidth ? 'px-4' : '')} ${('mb-' + this.localValue.marginBottom)}">`
            if(this.localValue.topButtonText && this.localValue.topButtonHref){
                this.localValue.htmlText += `
                    <div class="bluePaintButton">
                        <a class="btn btn-primary" href="${this.localValue.topButtonHref}">
                            ${this.localValue.topButtonText}
                        </a>
                    </div>
                `;
            }
            this.localValue.htmlText += `
                <div class="bluePaintText">
                    ${this.localValue.text}
                </div>
            </div>
        `;
    }

}
</script>
